import useAcvFeatureFlags from '@/views/TransportationHub/composables/useAcvFeatureFlags';
import EasyPassClient from './EasyPassClient';
import TransportGatewayClient from './TransportGatewayClient';

class TransportationClient {
  constructor(user) {
    this.easyPassClient = new EasyPassClient(user);
    this.easyPassMyAcvRootUri = 'bff/myacv/transportation/requests';
    this.easyPassRootUri = 'bff/transportation';
    this.easyPassHeaders = {
      'json-naming-strategy': 'camel',
    };
    this.retryCount = 1;
    this.formDataHeader = {
      'Content-Type': 'multipart/form-data',
    };
    this.transportGatewayClient = new TransportGatewayClient();
  }

  getTransportationData(auctionId) {
    return this.easyPassClient.get(`${this.easyPassMyAcvRootUri}/${auctionId}`);
  }

  getDecodedVin(vin) {
    return this.transportGatewayClient.getDecodedVin(vin);
  }

  getTransportationRequests({
    page,
    size,
    sort,
    search,
    statuses,
  }) {
    const acvFeatureFlags = useAcvFeatureFlags();
    const redirectVinDeocodeToTyk = acvFeatureFlags.getFlag('transportationSearchRequestRedirectToTyk');
    const enclosedEnabled = acvFeatureFlags.getFlag('transportationEnclosed');
    const driveawayEnabled = acvFeatureFlags.getFlag('transportationDriveaway');
    const includeServiceType = enclosedEnabled.value || driveawayEnabled.value;

    if (redirectVinDeocodeToTyk.value) {
      return this.transportGatewayClient.getTransportationRequests(
        page,
        size,
        sort,
        search,
        statuses,
        includeServiceType,
      );
    }
    const payload = {
      statuses,
      search,
    };

    const query = `page=${page}&size=${size}&sort=${sort || 'createdDate,desc'}`;

    return this.easyPassClient.post(
      `${this.easyPassRootUri}/requests/filter?${query}`,
      payload,
      this.easyPassHeaders,
      null,
      this.retryCount,
    );
  }

  getTransportationQuote(payload) {
    const acvFeatureFlags = useAcvFeatureFlags();
    const redirectGetQuoteToTyk = acvFeatureFlags.getFlag('transportationRedirectGetQuoteToTyk');
    return redirectGetQuoteToTyk.value
      ? this.transportGatewayClient.getOffPlatformTransportQuote(payload)
      : this.easyPassClient.post(`${this.easyPassRootUri}/quote`, payload);
  }

  getPromotions() {
    return this.transportGatewayClient.getPromotions();
  }

  getTransportContactByDealer(dealerId) {
    return this.transportGatewayClient.getTransportContactByDealer(dealerId);
  }

  createTransportationRequest(payload) {
    const acvFeatureFlags = useAcvFeatureFlags();

    const isAfterAuctionEnabled = acvFeatureFlags.getFlag('transportationAfterAuctionInApp');
    if (isAfterAuctionEnabled.value) {
      return this.transportGatewayClient.createBulkRequests(payload);
    }

    const redirectBulkCreateToTyk = acvFeatureFlags.getFlag('transportationRedirectCreateBulkRequestToTyk');
    return redirectBulkCreateToTyk.value
      ? this.transportGatewayClient.createOffPlatformBulkRequests(payload)
      : this.easyPassClient.post(`${this.easyPassRootUri}/requests/off-platform/bulk`, payload);
  }

  uploadGatePass(payload) {
    const newPayload = {
      gatePass: payload.file,
    };
    return this.transportGatewayClient.uploadGatePass(newPayload);
  }
}

export default TransportationClient;
